import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { DetailCardSimple } from '@/shared/components/layout';
import { Progress } from '@/shared/components/ui';

interface CustomerQuotaCardProps {
  icon?: LucideIcon;
  title: string;
  description?: ReactNode;
  usageLabel: ReactNode;
  totalUsage: number;
  quota: number;
  usageDetails?: ReactNode;
  quotaControl: ReactNode;
  className?: string;
}

export function CustomerQuotaCard({
  icon,
  title,
  description,
  usageLabel,
  totalUsage,
  quota,
  usageDetails,
  quotaControl,
  className,
}: CustomerQuotaCardProps) {
  return (
    <DetailCardSimple icon={icon} title={title} className={className}>
      {description && <div className="text-sm text-muted-foreground mb-6">{description}</div>}

      <div className="space-y-6">
        <div>
          <div className="flex justify-between text-sm mb-2">
            <span className="text-muted-foreground">{usageLabel}</span>
            <span className="font-medium text-foreground">
              {totalUsage} / {quota}
            </span>
          </div>
          <Progress value={quota > 0 ? (totalUsage / quota) * 100 : 0} className="h-2.5" />
          {usageDetails && <div className="text-sm text-muted-foreground mt-2">{usageDetails}</div>}
        </div>

        {quotaControl}
      </div>
    </DetailCardSimple>
  );
}
